/**
 * @package     Wordpress.Site
 * @subpackage  Templates.thanh2t
 *
 * @copyright   Copyright (C) 2020 thanh2t. All rights reserved.
 * @license     GNU General Public License version 2 or later; see LICENSE.txt
 */
import { fontAwesomeLoad } from 'root/utils/fontawesome';
import { faFacebookF } from '@fortawesome/free-brands-svg-icons/faFacebookF';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons/faEnvelope';
import { faPhone } from '@fortawesome/free-solid-svg-icons/faPhone';
import { faGlobeAsia } from '@fortawesome/free-solid-svg-icons/faGlobeAsia';
import { faTwitter } from '@fortawesome/free-brands-svg-icons/faTwitter';
//menu button
if (document.body.contains(document.getElementById('menu-btn'))) {
  document.getElementById('menu-btn').addEventListener('click', (event) => {
    document.querySelector('body').classList.toggle('menu-open');
  });
}
//search icon
if (document.body.contains(document.getElementById('search-btn'))) {
  document.getElementById('search-btn').addEventListener('click', (event) => {
    document.querySelector('.main_form').classList.toggle('show');
  });
}
//search icon close
if (document.body.contains(document.getElementById('closeIcon'))) {
  document.getElementById('closeIcon').addEventListener('click', (event) => {
    document.querySelector('.main_form').classList.remove('show');
  });
}

// load icon
fontAwesomeLoad('.fa-facebook-f', faFacebookF);
fontAwesomeLoad('.fa-envelope', faEnvelope);
fontAwesomeLoad('.fa-phone', faPhone);
fontAwesomeLoad('.fa-globe-asia', faGlobeAsia);
fontAwesomeLoad('.fa-twitter', faTwitter);
